<template>
  <select
    ref="select"
    class="form-select"
    v-model="$attrs.modelValue"
    v-bind="$attrs"
  >
    <slot name="default" />
    <option v-if="nullable" :value="null">
      {{ typeof nullable === 'string' ? nullable : '' }}
    </option>
    <option
      v-for="(option, key) in options"
      :key="key"
      :value="typeof option.value === 'undefined' ? key : option.value"
      :disabled="option.disabled"
    >
      {{ option.text || option.value || option }}
    </option>
  </select>
</template>

<script>
import { ref } from 'vue';

export default {
  inheritAttrs: false,
  props: {
    nullable: {
      type: [Boolean, String],
      default: false,
    },
    options: {
      type: [Array, Object],
      default: () => [],
    },
  },
  setup() {
    const select = ref();

    function focus() {
      select.value.focus();
    }

    return {
      select,
      focus,
    }
  }
}
</script>
